import { BaseEventProps } from "../../types";

export enum ModuleEventProps {
  BET_AMOUNT_OPTION = "Bet Amount Option"
}

export type EventProps = BaseEventProps | ModuleEventProps;

export enum MediatorEventType {
  SAVE_CHANGES = "BET_PREFERENCES:SAVE_CHANGES",
  NAVIGATE_MORE_PAGE = "BET_PREFERENCES:NAVIGATE_MORE_PAGE"
}

type BetAmountType = "minimum" | "custom";

export interface BetPreferenceData {
  type: MediatorEventType.SAVE_CHANGES;
  payload: {
    betType: string;
    betAmountOption: BetAmountType;
    tag?: string;
  };
}
